import { useState } from 'react';

function TabSwitch() {
  const [activeTab, setActiveTab] = useState('p2p');

  const switchTab = (tab) => {
    setActiveTab(tab);
    window.location.href = "https://3.rw/" + (tab === 'p2p' ? '1/' : '2/')
    // navigate(tab === 'p2p' ? '/1' : '/2');
  };

  return (
    
     
        <div className="flex bg-[#4E5C6280] border border-[#FFFFFF33] rounded-full  p-1">
          <button
            className={`sm:px-4 px-2 py-2  sm:py-2 rounded-full text-[15px] sm:text-[20px] font-medium  ${
              activeTab === 'p2p' ? 'bg-[#34C759] text-white' : 'text-gray-300 hover:text-white'
            }`}
            onClick={() => switchTab('p2p')}
          >
            P2P Mode
          </button>
          <button
            className={`sm:px-4 px-2 py-2  sm:py-2 rounded-full text-[15px] sm:text-[20px] font-medium ${
              activeTab === 'cloud' ? 'bg-[#A168FA] text-white' : 'text-gray-300 hover:text-white'
            }`}
            onClick={() => switchTab('cloud')}
          >
            Cloud Mode
          </button>
        </div>
      
  );
}

export default TabSwitch;